import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const PatientProfile = () => {
  const { auth } = useAuth();
  const { state } = useLocation();
  const [values, setValues] = useState({});
  const [alert, setAlert] = useState(state ? state : null);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    let timeoutId = setTimeout(() => {
      setAlert(null);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosPrivate.get(
          `user/patient/${auth?.user.id}/`
        );
        setValues(response?.data);
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Load Failed", "warning");
        }
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <AlertField alert={alert} />
      <div className="w-100 row row-cols-md-2">
        <div className="bg-light m-3 m-md-5 p-2 p-md-3">
          <div className="d-flex flex-column flex-md-row align-items-center mx-md-5 px-md-5">
            <div>
              <img
                src={values?.user_detail?.user_image || ""}
                className="rounded-circle border border-dark"
                width={200}
                height={200}
                alt="doctor"
              />
            </div>
            <div>
              <h4 className="ms-4 mt-2 mt-md-0">
                {values?.user_detail?.name || ""}
              </h4>
              <p className="ms-4 mb-1 h6">{values?.address || ""}</p>
            </div>
          </div>
          <div className="mx-2 mx-md-5 px-2 px-md-5 mt-2">
            <table className="table-sm table table-borderless">
              <tbody>
                <tr>
                  <td>
                    <h5>Age :</h5>
                  </td>
                  <td>
                    <h5>{values?.age || ""}</h5>
                  </td>
                </tr>

                <tr>
                  <td>
                    <h5>Gender :</h5>
                  </td>
                  <td>
                    <h5>{values?.gender || ""}</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Contact :</h5>
                  </td>
                  <td>
                    <h5>{values?.phone_number || ""}</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Email :</h5>
                  </td>
                  <td>
                    <h5>{values?.user_detail?.email || ""}</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Joined Date :</h5>
                  </td>
                  <td>
                    <h5>
                      {new Date(
                        values?.user_detail?.date_joined
                      ).toLocaleDateString() || ""}
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="text-end mx-5">
            <a href="/edit/profile" className="px-5 btn btn-primary">
              Edit
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientProfile;
